// One chart of a box's history (System > box): the server names the queries, this card asks for a panel and a range.
import { useQuery } from '@tanstack/react-query';
import { getSystemHostSeriesOptions } from '../../../generated/api/@tanstack/react-query.gen.js';
import type { GetSystemHostSeriesData } from '../../../generated/api/types.gen.js';
import type { MetricRange } from './metric-format.js';
import { refreshFor } from './RangePills.js';
import { SeriesChartCard } from './SeriesChartCard.js';

export type HostPanel = GetSystemHostSeriesData['query']['panel'];

interface HostMetricChartProps {
  hostId: string;
  panel: HostPanel;
  range: MetricRange;
  title: string;
  description?: string;
  area?: boolean;
}

export function HostMetricChart({ hostId, panel, range, title, description, area }: HostMetricChartProps) {
  const query = useQuery({
    ...getSystemHostSeriesOptions({ path: { id: hostId }, query: { panel, range } }),
    refetchInterval: refreshFor(range),
  });
  return (
    <SeriesChartCard
      title={title}
      description={description}
      range={range}
      data={query.data}
      loading={query.isPending}
      error={query.error}
      area={area}
    />
  );
}
